import { resolveWallRewardClearSpeed } from "./wallRewardClearSpeed";
import type { WallDefinition } from "./wallDefinitions";
import { MP_WALL_BALANCE_PROFILE } from "./wallBalanceProfiles";
import {
  DEFAULT_WALL_REWARD_CAP_LEVEL,
  type WallRewardCapLevel,
} from "./wallRewardCap";

export const MP_WALL_DEFINITION: WallDefinition = {
  id: "mp-wall",
  firstClearReward: MP_WALL_BALANCE_PROFILE.firstClearReward,
};

export const MP_WALL_REWARD_MIN_MP_BONUS =
  MP_WALL_BALANCE_PROFILE.reward.minimumMpBonus;
export const MP_WALL_REWARD_BASE_CAP_MP_BONUS =
  MP_WALL_BALANCE_PROFILE.reward.caps.base;
export const MP_WALL_REWARD_RELAXED_CAP_MP_BONUS =
  MP_WALL_BALANCE_PROFILE.reward.caps.relaxed;
export const MP_WALL_REWARD_TARGET_CLEAR_MS =
  MP_WALL_BALANCE_PROFILE.reward.targetClearMs;

export function resolveMpWallRewardEffectiveMaxMpBonus(
  capLevel: WallRewardCapLevel = DEFAULT_WALL_REWARD_CAP_LEVEL,
): number {
  return capLevel === "relaxed"
    ? MP_WALL_REWARD_RELAXED_CAP_MP_BONUS
    : MP_WALL_REWARD_BASE_CAP_MP_BONUS;
}

export function resolveMpWallRewardMpBonus(
  bestClearMs: number | null,
  effectiveMaxMpBonus: number = resolveMpWallRewardEffectiveMaxMpBonus(),
): number {
  if (bestClearMs === null) return 0;
  if (!Number.isFinite(bestClearMs) || bestClearMs <= 0) {
    return effectiveMaxMpBonus;
  }
  const raw = Math.round(
    resolveWallRewardClearSpeed(
      bestClearMs,
      MP_WALL_REWARD_TARGET_CLEAR_MS,
      MP_WALL_BALANCE_PROFILE.reward.softcapClearMs,
    ),
  );
  return Math.min(
    effectiveMaxMpBonus,
    Math.max(MP_WALL_REWARD_MIN_MP_BONUS, raw),
  );
}
